export const ProfileFormActionType = {
   SET_BIO: "SET_BIO",
   SET_WEBSITE: "SET_WEBSITE",
   SET_PROFILE_PIC: "SET_PROFILE_PIC",
   SET_UPLOAD_PROFILE_PIC: "SET_UPLOAD_PROFILE_PIC",
   RESET_FORM: "RESET_FROM",
};

Object.freeze(ProfileFormActionType);
